import { useEffect, useState } from "react";
import { toast } from "sonner";
import { api, API, fmtGBP, fmtDDMMYYYY } from "../../api";
import { PageHeader, Panel, Btn, Input, Select, Empty } from "../../ui";

export default function FeesPage() {
  const [list, setList] = useState(null);
  const [apps, setApps] = useState([]);
  const [brokers, setBrokers] = useState([]);
  const [show, setShow] = useState(false);
  const [f, setF] = useState({ case_id: "", broker_user_id: "", expected: "", trigger: "completion", due_date: "" });

  const load = async () => {
    const [ff, aa, bb] = await Promise.all([api.get(`${API}/fees`), api.get(`${API}/applications`), api.get(`${API}/users?role=broker`)]);
    setList(ff.data); setApps(aa.data); setBrokers(bb.data);
  };
  useEffect(() => { load(); }, []);
  const create = async (e) => {
    e.preventDefault();
    try {
      await api.post(`${API}/fees`, { ...f, expected: Number(f.expected) || 0 });
      toast.success("Fee tracked"); setShow(false);
      setF({ case_id: "", broker_user_id: "", expected: "", trigger: "completion", due_date: "" });
      load();
    } catch (err) { toast.error(err.response?.data?.detail || "Could not save"); }
  };
  const markReceived = async (fee) => {
    const amt = Number(prompt("Received amount in £", String(fee.expected))) || 0;
    if (!amt) return;
    await api.put(`${API}/fees/${fee.id}`, { received_amount: amt, received_at: new Date().toISOString() });
    toast.success("Payment recorded"); load();
  };
  return (
    <div>
      <PageHeader title="Completions & Referral fees" subtitle="Track the fee we expect from each broker, when it's triggered, and when it's received." action={<Btn onClick={() => setShow(true)}>+ Track fee</Btn>} />
      {show && (
        <Panel className="p-6 mb-6">
          <form onSubmit={create} className="grid grid-cols-1 sm:grid-cols-2 gap-4">
            <Select label="Case" required value={f.case_id} onChange={(e) => setF({ ...f, case_id: e.target.value })}><option value="">— pick —</option>{apps.map(a => <option key={a.id} value={a.id}>{a.ref}</option>)}</Select>
            <Select label="Broker" required value={f.broker_user_id} onChange={(e) => setF({ ...f, broker_user_id: e.target.value })}><option value="">— pick —</option>{brokers.map(b => <option key={b.id} value={b.id}>{b.name}</option>)}</Select>
            <Input label="Expected (£)" type="number" required value={f.expected} onChange={(e) => setF({ ...f, expected: e.target.value })} />
            <Select label="Trigger" value={f.trigger} onChange={(e) => setF({ ...f, trigger: e.target.value })}><option value="completion">On completion</option><option value="offer">On offer received</option><option value="submission">On application submission</option></Select>
            <Input label="Due date" type="date" value={f.due_date} onChange={(e) => setF({ ...f, due_date: e.target.value })} />
            <div className="sm:col-span-2 flex justify-end gap-2"><Btn variant="ghost" type="button" onClick={() => setShow(false)}>Cancel</Btn><Btn type="submit">Save</Btn></div>
          </form>
        </Panel>
      )}
      {list === null ? <p className="text-sm text-slate-500">Loading…</p> : list.length === 0 ? <Empty title="No fees tracked yet" /> : (
        <Panel>
          <table className="w-full text-sm">
            <thead><tr className="border-b border-slate-200 text-[10.5px] tracking-[0.14em] uppercase text-slate-500 bg-slate-50"><th className="text-left px-5 py-3">Case</th><th className="text-left px-5 py-3">Trigger</th><th className="text-left px-5 py-3">Due</th><th className="text-left px-5 py-3">Expected</th><th className="text-left px-5 py-3">Received</th><th /></tr></thead>
            <tbody>
              {list.map(fee => {
                const bal = Number(fee.expected || 0) - Number(fee.received_amount || 0);
                return (
                  <tr key={fee.id} className="border-b border-slate-100">
                    <td className="px-5 py-3 font-mono">{fee.case_id.slice(0, 8)}…</td>
                    <td className="px-5 py-3 text-slate-600">{fee.trigger}</td>
                    <td className="px-5 py-3 text-slate-600">{fmtDDMMYYYY(fee.due_date)}</td>
                    <td className="px-5 py-3 font-semibold">{fmtGBP(fee.expected)}</td>
                    <td className="px-5 py-3 text-emerald-700">{fmtGBP(fee.received_amount || 0)}</td>
                    <td className="px-5 py-3 text-right">{bal > 0 && <button className="text-[11px] font-bold tracking-[0.14em] uppercase text-emerald-700 hover:underline" onClick={() => markReceived(fee)}>Mark received</button>}</td>
                  </tr>
                );
              })}
            </tbody>
          </table>
        </Panel>
      )}
    </div>
  );
}
